import React from 'react';
// Справочники модуля «Гражданские дела»

export const CASE_STAGES = [
  { key: 'consultation', label: 'Консультация',        color: '#6366f1' },
  { key: 'contract',     label: 'Договор',             color: '#0ea5e9' },
  { key: 'pretrial',     label: 'Досудебный порядок',  color: '#14b8a6' },
  { key: 'court',        label: 'Суд 1 инстанции',     color: '#f59e0b' },
  { key: 'appeal',       label: 'Обжалование',         color: '#ef4444' },
  { key: 'enforcement',  label: 'Исполнение',          color: '#8b5cf6' },
  { key: 'completed',    label: 'Завершено',           color: '#10b981' },
  { key: 'refused',      label: 'Отказ',               color: '#9ca3af' },
];
export const CASE_STAGE_MAP = Object.fromEntries(CASE_STAGES.map(s => [s.key, s]));

export const CASE_CATEGORIES = [
  { key: 'family',       label: 'Семейный спор',            color: '#ec4899' },
  { key: 'alimony',      label: 'Алименты',                 color: '#f472b6' },
  { key: 'inheritance',  label: 'Наследство',               color: '#a16207' },
  { key: 'debt',         label: 'Взыскание долга',          color: '#0891b2' },
  { key: 'creditors',    label: 'Защита от кредиторов',     color: '#0e7490' },
  { key: 'enforcement',  label: 'Приставы / ИП',            color: '#475569' },
  { key: 'housing',      label: 'Жилищный спор',            color: '#65a30d' },
  { key: 'land',         label: 'Земельный спор',           color: '#15803d' },
  { key: 'realty',       label: 'Недвижимость / сделки',    color: '#0f766e' },
  { key: 'labor',        label: 'Трудовой спор',            color: '#ca8a04' },
  { key: 'consumer',     label: 'Защита прав потребителей', color: '#ea580c' },
  { key: 'dtp',          label: 'ДТП / ОСАГО',              color: '#dc2626' },
  { key: 'admin',        label: 'Административное дело',    color: '#7c3aed' },
  { key: 'arbitration',  label: 'Арбитраж',                 color: '#1d4ed8' },
  { key: 'subsidiary',   label: 'Субсидиарная ответственность', color: '#1e40af' },
  { key: 'svo',          label: 'Участник СВО',             color: '#166534' },
  { key: 'documents',    label: 'Составление документов',   color: '#64748b' },
  { key: 'other',        label: 'Другое',                   color: '#6b7280' },
];
export const CASE_CATEGORY_MAP = Object.fromEntries(CASE_CATEGORIES.map(c => [c.key, c]));

export const CASE_ROLES = [
  { key: 'none',       label: 'Без суда' },
  { key: 'plaintiff',  label: 'Истец' },
  { key: 'defendant',  label: 'Ответчик' },
  { key: 'applicant',  label: 'Заявитель' },
  { key: 'third',      label: 'Третье лицо' },
  { key: 'debtor',     label: 'Должник (ИП)' },
  { key: 'claimant',   label: 'Взыскатель (ИП)' },
];
export const CASE_ROLE_MAP = Object.fromEntries(CASE_ROLES.map(r => [r.key, r]));

export const CASE_RESULTS = [
  { key: 'won',        label: 'Выиграно',              color: '#10b981' },
  { key: 'partial',    label: 'Частично',              color: '#f59e0b' },
  { key: 'settlement', label: 'Мировое соглашение',    color: '#0ea5e9' },
  { key: 'lost',       label: 'Проиграно',             color: '#ef4444' },
  { key: 'done',       label: 'Услуга оказана',        color: '#6366f1' },
  { key: 'client_out', label: 'Клиент отказался',      color: '#9ca3af' },
];
export const CASE_RESULT_MAP = Object.fromEntries(CASE_RESULTS.map(r => [r.key, r]));

export const Chip = ({ color, children }) => (
  <span style={{ fontSize: 11, padding: '1px 8px', borderRadius: 10, background: color + '22', color, fontWeight: 600, whiteSpace: 'nowrap' }}>{children}</span>
);

export const toDateInput = d => (d ? String(d).slice(0, 10) : '');

// Типовые досудебные действия по категориям — кнопка «Добавить типовые» во вкладке «Досудебные действия»
export const PRETRIAL_TEMPLATES = {
  dtp: [
    ['Получить материалы ДТП (схема, определение, объяснения)', 'ГИБДД / аварийный комиссар'],
    ['Заявление об установлении владельца животных и проверке', 'ОМВД по району'],
    ['Запрос о владельце животных (учёт скота в хозяйствах)', 'Администрация сельского поселения'],
    ['Запрос об учёте животных (бирки, чипы)', 'Районная ветстанция'],
    ['Независимая оценка ущерба', 'Эксперт-оценщик'],
    ['Досудебная претензия о возмещении ущерба', 'Виновник / владелец'],
  ],
  debt: [
    ['Досудебная претензия', 'Должник'],
    ['Заявление о выдаче судебного приказа', 'Мировой судья'],
  ],
  consumer: [
    ['Претензия', 'Продавец / исполнитель'],
    ['Жалоба', 'Роспотребнадзор'],
  ],
  labor: [
    ['Заявление о выдаче документов о работе', 'Работодатель'],
    ['Жалоба', 'Государственная инспекция труда'],
  ],
  inheritance: [
    ['Запрос о наследственном деле', 'Нотариус'],
    ['Запрос сведений', 'ЗАГС'],
    ['Запрос выписки ЕГРН', 'Росреестр'],
  ],
  housing: [
    ['Обращение', 'Управляющая организация'],
    ['Жалоба', 'Госжилинспекция'],
    ['Досудебная претензия', 'Другая сторона'],
  ],
  land: [
    ['Выписка ЕГРН на участки', 'Росреестр'],
    ['Заключение о границах', 'Кадастровый инженер'],
    ['Досудебная претензия', 'Сосед'],
  ],
  family: [['Проект соглашения, переговоры', 'Другая сторона']],
  alimony: [['Проект соглашения об уплате алиментов', 'Другая сторона']],
  arbitration: [['Претензия (ч. 5 ст. 4 АПК РФ)', 'Должник']],
};
